<template lang="html">
	<entity-page id="page__additional_services_price" v-bind:loading="progress">
		<template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>

        <z-select
            name="service_id" id="service_id" label="Услуга" v-bind:required="true" v-model="price.service_id" @change="clearPrice"
            v-validate="{required: true}" v-bind:error="errors.first('service_id')"  data-vv-name="service_id" v-bind:data-vv-as="' '"
        >
            <option value="" selectd disabled>Не установлена</option>
            <option v-for="service in Object.values(services)" v-bind:value="service.id">{{service.name}}</option>
        </z-select>
		
		<div v-if="selectedService && ['grid-dimensions', 'grid-city-dimensions'].includes(selectedService.type)">
			<div class="row">
				<z-select
					label="Тип расчёта" v-model="price.type" :required="true" name="type" id="type" class="col-6"
					v-validate="{required: ['grid-city', 'grid-city-dimensions'].includes(selectedService.type)}"
					v-bind:data-vv-as="' '" v-bind:error="errors.first('type')"
				>
					<option v-bind:value="null" selected disabled>Выбрать...</option>
					<option v-for="type in selectedTypes" v-bind:value="type.value">{{ type.name }}</option>
				</z-select>
				<z-select
					v-bind:label="'Тип расчёта цены по' + (parseInt(price.type) == 2 ? ' объёму' : ' весу')" class="col-6"
					v-model="price.is_min" :required="true" name="is_min" id="is_min"
					v-validate="{required: ['grid-city', 'grid-city-dimensions'].includes(selectedService.type)}"
					v-bind:data-vv-as="' '" v-bind:error="errors.first('is_min')"
				>
					<option v-bind:value="null" selected disabled>Выбрать...</option>
					<option v-bind:value="0">{{ 'За единицу' + (parseInt(price.type) == 2 ? ' объёма' : ' веса')}}</option>
					<option v-bind:value="1">{{ 'За весь' + (parseInt(price.type) == 2 ? ' объём' : ' вес') }}</option>
				</z-select>
			</div>

			<div class="row">
				<z-input
					:label="`Минимальный ${(parseInt(price.type) == 1 ? ' вес' : ' объём')}`"
					v-model="price.value_min" name="value_min" id="value_min" class="col-6" data-vv-name="value_min"
					v-validate="{required: ['grid-city', 'grid-city-dimensions'].includes(selectedService.type), min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
					v-bind:error="errors.first('value_min')" type="number" v-bind:data-vv-as="' '" required
				></z-input>
				<z-input
					:label="`Максимальный ${(parseInt(price.type) == 1 ? ' вес' : ' объём')}`"
					v-model="price.value_max" name="value_max" id="value_max" class="col-6" data-vv-name="value_max"
					v-validate="{required: ['grid-city', 'grid-city-dimensions'].includes(selectedService.type), min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
					v-bind:error="errors.first('value_max')" type="number" v-bind:data-vv-as="' '" required
				></z-input>
			</div>
		</div>

		<div v-if="selectedService && ['grid-city', 'grid-city-dimensions'].includes(selectedService.type)" class="row">
			<div class="col-6">
				<z-input-autocomplete
					name="city_id_from" id="city_id_from" display-property="name" property="id" return="id" label="Город отправления"
					v-model="price.city_id_from" v-bind:callback="getCities" v-bind:default="price.city && price.city.name ? price.city.name : ''"
					v-validate="{required: false}" v-bind:error="errors.first('city_id_from')" v-bind:data-vv-as="' '"
				></z-input-autocomplete>
				<b>или</b>
				<z-input-autocomplete
					v-model="price.zone_id_from" name="zone_id_from" id="zone_id_from" display-property="name" property="id" return="id" label="Направление отправления"
					v-bind:callback="getZones" v-bind:default="price.zone && price.zone.name ? price.zone.name : ''"
					v-validate="{required: false}" v-bind:error="errors.first('zone_id_from')" v-bind:data-vv-as="' '"
				></z-input-autocomplete>
			</div>
			<div class="col-6">
				<z-input-autocomplete
					name="city_id_to" id="city_id_to" display-property="name" property="id" return="id" label="Город назначения"
					v-model="price.city_id_to" v-bind:callback="getCities" v-bind:default="price.city && price.city.name ? price.city.name : ''"
					v-validate="{required: false}" v-bind:error="errors.first('city_id_to')" v-bind:data-vv-as="' '"
				></z-input-autocomplete>
				<b>или</b>
				<z-input-autocomplete
					v-model="price.zone_id_to" name="zone_id_to" id="zone_id_to" display-property="name" property="id" return="id" label="Направление назначения"
					v-bind:callback="getZones" v-bind:default="price.zone && price.zone.name ? price.zone.name : ''"
					v-validate="{required: false}" v-bind:error="errors.first('zone_id_to')" v-bind:data-vv-as="' '"
				></z-input-autocomplete>				
			</div>
		</div>

		<div v-if="selectedService && selectedService.type === 'grid-paymethod'">
			<z-select
				name="payment_method_id" id="payment_method_id" label="Способ оплаты" v-bind:required="true" v-model="price.payment_method_id"
				v-validate="{required: true}" v-bind:error="errors.first('payment_method_id')"  data-vv-name="payment_method_id" v-bind:data-vv-as="' '"
			>
				<option value="" selectd disabled>Не установлен</option>
				<option v-for="item in Object.values(paymentMethods)" v-bind:value="item.id">{{item.name}}</option>
			</z-select>
		</div>

        <z-input
			v-model="price.price" name="price" id="price" label="Цена (руб.)" type="number"
			v-validate="{required: true, min_value: 0}" v-bind:error="errors.first('price')" v-bind:required="true"
			data-vv-name="price" v-bind:data-vv-as="' '"
		></z-input>
    </entity-page>
</template>
<script>
	import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
	import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton';
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	export default {
		components: { ZInputAutocomplete, ZInput, ZSelect, ZIconButton, EntityPage },
		data() {
			return {
				price: {},
				priceDefault: {
					id:   null,
					type: null,
					is_min: 0,
					price:  0,
					value_min: 0,
					value_max: 0,
					service_id: null,
					payment_method_id: null,
					city_id_from: null,
					city_id_to:   null,
					zone_id_from: null,
					zone_id_to:   null,
				},
				services: [],
				paymentMethods: [],
                types: [
                    {
                        name: 'По весу',
                        value: 1,
						types: ['grid-dimensions', 'grid-city-dimensions']
                    },
                    {
                        name: 'По объёму',
                        value: 2,
						types: ['grid-dimensions', 'grid-city-dimensions']
                    }
                ]
			}
		},
		computed: {
			progressKey() {
				return 'load-additional-services-price-card';
			},
			/**
             * Флаг загрузки текущего компонента
             */
			progress() {
				return this.progressObj[this.progressKey];
			},
			/**
             * Объект с флагами загрузки
             */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Выбранная услуга
			 */
			selectedService() {
				return this.services.find((item) => item.id == this.price.service_id);
			},
			selectedTypes() {
				return this.types.filter(type => this.selectedService && type.types.includes(this.selectedService.type));
			}
		},
		watch: {
			'$route.params.id'() {
				this.init();
			}
		},
		methods: {
			/**
             * Инициализация компонента
             */
			init() {
				this.$store.commit('openRightPanel');
				if (this.$route.params.id !== 'new') this.getPrice();
				else this.price = Object.assign({}, this.priceDefault);
				this.getServices();
				this.getPaymentMethods();
			},
			clearPrice() {
				this.price = Object.assign({}, this.priceDefault);
			},
			/**
			 * Получение ценгы
			 */
			getPrice() {
				this.$store.commit('showProgressBar', this.progressKey);
				return this.$store.dispatch('cost/getAdditionalServicesPriceId', this.$route.params.id).then(r => {
					this.price = Object.assign({}, r);
					return this.price;
				}).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
			},
			/**
			 * Сохранение
			 */
			save() {
				this.$validator.validateAll().then(valid => {
					if (!valid) return;
					if (this.$route.params.id != 'new') this.putPrice();
                    else this.postPrice();
				});
			},
			/**
			 * Добавление цены
			 */
			postPrice() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', this.progressKey);
                    this.$store.dispatch('cost/postAdditionalServicesPrice', this.price).then(r => {
                        this.$root.$emit('reload-table', 'additional-services-prices');
                        this.$router.replace({name: 'AdditionalServicesPrice', params: {id: r.id}});
                    }).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
                });
			},
			/**
			 * Изменение цены
			 */
			putPrice() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', this.progressKey);
                    this.$store.dispatch('cost/putAdditionalServicesPrice', this.price).then(r => {
                        if (!r) return;
                        this.init();
                        this.$root.$emit('reload-table', 'additional-services-prices');
                    }).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
                });
			},
			/**
			 * Получение услуг
			 */
			getServices() {
				this.$store.commit('showProgressBar', this.progressKey);
				return this.$store.dispatch('cost/getAdditionalServices', {
					page: 1,
					order_by: 'id',
					order_type: 'asc',
					count: 'all',
					filter: {model: [
						['active', '=', 1], 'and',
						['type', '=%', 'grid-']
					]},
					nocache: true
				}).then(r => {
					if (!r || !Array.isArray(r)) return [];
					this.services = Object.assign([], r);
					return this.services;
				}).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
			},
			getPaymentMethods() {
				this.$store.commit('showProgressBar', this.progressKey);
				return this.$store.dispatch('cost/getPaymentMethods', {
					page: 1,
					order_by: 'id',
					order_type: 'asc',
					count: 'all',
					filter: {model: [['active', '=', 1]]}
				}).then(r => {
					if (!r || !Array.isArray(r)) return [];
					this.paymentMethods = Object.assign([], r);
					return this.paymentMethods;
				}).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
			},
			/**
			 * Получение направлений
			 */
			getZones(string) {
				if (string && string.length > 3) return this.$store.dispatch('cost/getZones', {
					page: 1, count: 20,
					filter: {model: [['name', '%', string]]}
				});
			},
            /**
             * Подставление города
             */
             getCities(searchString) {
                if (searchString && searchString.length >= 3) return this.$store.dispatch('cost/getCities', {
                    page: 1, count: 20,
                    filter: {model: [['name', '%', searchString], 'or', ['value', '%', searchString]]} 
                });
            },            
			/**
             *Возвращает пользователя на предыдущую страницу
            * Обрабочик события click, на кнопке "Закрыть" 
            */
			back() {
                this.$router.push({name: 'AdditionalServicesPrices', query: this.$route.query});
            }
		},
		created() {
			this.init();
		}		
	}
</script>


// WEBPACK FOOTER //
// AdditionalServicesPrice.vue?09824584